import type { PublicDeletionStartData } from '../api/usePublicDeletion'

/** Identity anti-enumeration: OTP issued only when maskedEmail is non-empty on HTTP 200. */
export function extractPublicDeletionMaskedEmail(
  data: PublicDeletionStartData | null | undefined
): string | null | undefined {
  if (data == null) return undefined
  const raw = data.maskedEmail
  if (raw === null) return null
  if (typeof raw === 'string') return raw
  return undefined
}

export function isPublicDeletionOtpIssued(
  maskedEmail: string | null | undefined
): boolean {
  return typeof maskedEmail === 'string' && maskedEmail.trim().length > 0
}
